import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectSystemEvchargeTelemetry = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.EvchargeTelemetryComponent
);

export const selectSystemEvchargeTelemetryBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemEvchargeTelemetry,
  (systemState, evchargeTelemetryComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return [];
    }

    const instanceBlock = evchargeTelemetryComponent[instanceId];
    if (!instanceBlock) {
      return [];
    }

    return instanceBlock[selectedSystem]?.telemetryData ?? [];
  }
);

export const selectedEvchargeTelemetryRequestStatus = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemEvchargeTelemetry,
  (systemState, evchargeTelemetryComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return 'initial';
    }

    const instanceBlock = evchargeTelemetryComponent[instanceId];
    if (!instanceBlock) {
      return 'initial';
    }

    return instanceBlock[selectedSystem]?.state ?? 'initial';
  }
);

export const selectSystemEvchargeTelemetryError = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemEvchargeTelemetry,
  (systemState, evchargeTelemetryComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = evchargeTelemetryComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.error ?? null;
  }
);